import type { Application } from '@hotwired/stimulus';
import { Controller } from '@hotwired/stimulus';

export class CardActionSelectionController extends Controller<HTMLElement> {
    declare readonly optionTarget: HTMLLIElement;
    declare readonly optionTargets: HTMLLIElement[];

    declare readonly activeOptionClasses: string[];

    static targets = ['option'];
    static classes = ['activeOption'];

    static register(application: Application) {
        application.register('card-action-selection', this);
    }

    connect() {
        console.log('Card Action Selection connected');
    }

    activateOption(event: Event) {
        const option = event.currentTarget as HTMLElement;

        const disabledOptions = this.optionTargets.filter((o) => o !== option);

        disabledOptions.forEach((otherOption) => {
            otherOption.classList.remove(...this.activeOptionClasses);
        });

        option.classList.add(...this.activeOptionClasses);
    }
}
